<template lang="html">
<div class="station-details streamflow">

    <div class="loading" v-if="!queryDone">
        <p>Loading station data...</p>
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div class="station" v-if="station && queryDone">

        <h3 class="headline station-name primary--text" v-text="queryData.name"></h3>

        <p class="body-2 mb-1 network-info">
            {{ networkId }}<br>
            <a target="_blank" :href="networkUrl">{{ network }}</a>
        </p>

        <hr class="my-3">

        <div
        v-for="{ title, value } in properties"
        v-if="value"
        class="properties-item mb-3">
            <h4 class="subheading field-title grey--text" v-text="title"></h4>
            <div class="body-1 field-value" v-text="value"></div>
        </div>

        <hr class="my-3">

        <download-csv-button :redistribute="dataRedistirbute" :station-id="stationId" />

        <h3 class="mt-3 mb-1 subheading">7-day Flow</h3>
        <spark-line id="seven-day-sparkline" height="76" width="300"
        :datasets="sevenDayFlowDatasets"
        @click="showChartModal('seven-day-flow')"
        v-if="checkChartData(this.queryData, 'seven_day_flow', this.checkStreamflowDataFields.seven_day_flow)"
        />
        <div
        v-if="!checkChartData(this.queryData, 'seven_day_flow', this.checkStreamflowDataFields.seven_day_flow)"
        class="no-data grey lighten-2 grey--text">
            <span>No data available</span>
        </div>

        <hr class="my-3">

        <h3 class="mt-3 mb-1 subheading">Stage</h3>
        <spark-line id="stage-sparkline" height="76" width="300"
        :datasets="stageDatasets"
        @click="showChartModal('stage')"
        v-if="checkChartData(this.queryData, 'stage', this.checkStreamflowDataFields.stage)"
        />
        <div
        v-if="!checkChartData(this.queryData, 'stage', this.checkStreamflowDataFields.stage)"
        class="no-data grey lighten-2 grey--text">
            <span>No data available</span>
        </div>

        <hr class="my-3">

    </div>

</div>
</template>

<script>
import pluralize from 'pluralize';
import checkQueryData from '@/mixins/checkQueryData';
import streamflowData from '@/mixins/streamflowData';
import getStationMetadata from '@/mixins/getStationMetadata';

import * as actions from '@/constants/actions';

// components
import SparkLine from '@/components/SidebarSparkline';
import DownloadCsvButton from '@/components/DownloadCsvButton';

export default {
    name: 'station-details-streamflow',
    mixins: [
        checkQueryData,
        streamflowData,
        getStationMetadata,
    ],
    components: {
        SparkLine,
        DownloadCsvButton,
    },
    computed: {
        stationId() {
            return this.station.id;
        },
    },
    methods: {
        pluralize(term, num) {
            return pluralize(term, num);
        },
        showChartModal(tabName) {
            this.$store.dispatch(actions.SET_CHART_MODAL_TAB, tabName);
            this.$store.dispatch(actions.SHOW_CHART_MODAL, true);
        },
    },
};
</script>

<style scoped lang="scss">
a {
    text-decoration: none;
    color: #000;
}

.station-details {
    .no-data {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 5rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarStationStreamflow.vue